var getDatePickerTheme = theme => ({
  colors: {
    buttonText: {
      initial: theme.colors.greys[100],
      disabled: theme.colors.greys[40]
    },
    buttonBackground: {
      selected: theme.colors.ultraViolets[70],
      hover: theme.colors.ultraViolets[70]
    },
    today: {
      initial: theme.colors.ultraViolets[70]
    },
    tableText: {
      initial: theme.colors.greys[50]
    }
  }
});
export { getDatePickerTheme };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0ZVBpY2tlci5qcyIsInNvdXJjZXMiOltdLCJzb3VyY2VzQ29udGVudCI6W10sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiIifQ==
